import React from "react";
import "../Button/Button.css";
const Button = (props) => {
  const { id, disabled, name, style, type, title, onClick, className, buttonType, icon  } = props;

  const handleClick = (e) => {
    e.preventDefault();
    onClick && onClick(e);
  };

  const ButtonType = () => {
    if (disabled) return "disabledButton"
    else if (buttonType === 'cancel') return "cancelButton"
    else if (buttonType === 'next') return "nextButton"
    else return "defaultButton"
  }

  return (
    <>
      <button
        className={className ? className : ButtonType()}
        id={id}
        disabled={disabled}
        name={name}
        style={style}
        type={type}
        onClick={handleClick}
      >
        {icon}{title}
      </button>
    </>
  );
};

export default Button;
